import { Row } from 'antd';
import classNames from 'classnames/bind';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import styles from './ReceiveRewardedSuccess.module.scss';
import config from '~/config';

const cx = classNames.bind(styles);
const BookingContent = styled.div`
    .ant-divider-horizontal {
        margin: 0px;
    }
`;

const ReceiveRewardedSuccess = ({ msg }) => {
    const navigate = useNavigate();
    return (
        <BookingContent>
            <Row align="middle" justify="center" className={cx('name_page')}>
                <span>Successfully received reward</span>
            </Row>

            <Row align="middle" className={cx('header')}>
                {msg}
            </Row>
            <Row style={{ marginTop: '20px' }}>
                <div className={cx('btn_login')} onClick={() => navigate(config.routes.downloadAPP)}>
                    Done
                </div>
            </Row>
            {/* <Divider />
            <Row className={cx('body')} gutter={[0, 32]}>
                <Col span={24} className={`${cx('install_app')} gutter-row`}>
                    <Row justify="space-around" className={cx('qr_section')}>
                        <a href="https://vbeauty.app.link/download" target="_blank" rel="noreferrer">
                            <img src={IMAGES.IconDownloadApp} alt="" className={cx('qr_img')} />
                        </a>
                    </Row>
                    <Row justify="center" className={cx('bio')}>
                        Download now
                    </Row>
                </Col>
            </Row> */}
        </BookingContent>
    );
};

export default ReceiveRewardedSuccess;
